module.exports = __webpack_public_path__ + "img/logo.4955e372.svg";